const membersEn = {
  "admin.members.text0": "Synced",
  "admin.members.text1": "Exported",
  "admin.members.text2": "New",
  "admin.members.text3": "Never exported to Proton",
  "admin.members.text4": "Present in Proton",
  "admin.members.text5": "in Proton",
  "admin.members.text6": "Proton history",
  "admin.members.text7": "Reset Proton status",
  "admin.members.text8": "Error loading members",
  "admin.members.text9": "Error loading registrations",
  "admin.members.text10": "Access granted",
  "admin.members.text11": "Access revoked",
  "admin.members.text12": "Error updating",
  "admin.members.text13": "Status updated",
  "admin.members.text14": "WhatsApp invitation sent successfully",
  "admin.members.text15": "Error sending invitation",
  "admin.members.text16": "Magic link sent successfully",
  "admin.members.text17": "Error sending magic link",
  "admin.members.text18": "Access granted successfully. 2 emails sent.",
  "admin.members.text19": "Error granting access",
  "admin.members.text20": "Magic link resent successfully",
  "admin.members.text21": "Member deleted successfully",
  "admin.members.text22": "Error deleting member",
  "admin.members.text23": "Error loading history",
  "admin.members.text24": "Error loading acceptance evidence",
  "admin.members.text25": "Error loading notes",
  "admin.members.text26": "Note added",
  "admin.members.text27": "Error adding note",
  "admin.members.text28": "Note deleted",
  "admin.members.text29": "Error deleting note",
  "admin.members.text30": "Contacted",
  "admin.members.text31": "Added to group",
  "admin.members.text32": "Removed from group",
  "admin.members.text33": "Word of mouth",
  "admin.members.text34": "Press / Media",
  "admin.members.text35": "Social media",
  "admin.members.text36": "First name",
  "admin.members.text37": "Phone",
  "admin.members.text38": "Yes",
  "admin.members.text39": "No",
  "admin.members.text40": "CSV exported successfully",
  "admin.members.text41": "No new members to export (all filtered members have already been exported).",
  "admin.members.text42": "No members to export (removed registrations are excluded).",
  "admin.members.text43": "Proton sync removed",
  "admin.members.text44": "Marked as synced",
  "admin.members.text45": "No selection to mark (already synced or empty).",
  "admin.members.text46": "Error marking members",
  "admin.members.text47": "Error resetting",
  "admin.members.text48": "Proton status reset",
  "admin.members.text49": "Error loading history",
  "admin.members.text50": "No eligible registrations",
  "admin.members.text51": "Member management",
  "admin.members.text52": "Registrations (",
  "admin.members.text53": ")",
  "admin.members.text54": "Manage registrations and member access",
  "admin.members.text55": "Export vCard",
  "admin.members.text56": "vCard export for Proton",
  "admin.members.text57": "Removed registrations are always excluded.",
  "admin.members.text58": "What would you like to export?",
  "admin.members.text59": "All filtered members",
  "admin.members.text60": "My selection (",
  "admin.members.text61": "Exclude previously exported members",
  "admin.members.text62": "Incremental export: skips members already exported to Proton.",
  "admin.members.text63": "contact",
  "admin.members.text64": "in the export",
  "admin.members.text65": "Download (",
  "admin.members.text66": "Export CSV",
  "admin.members.text67": "Search (name, email, phone)...",
  "admin.members.text68": "WhatsApp: all",
  "admin.members.text69": "WhatsApp accepted",
  "admin.members.text70": "WhatsApp declined",
  "admin.members.text71": "All",
  "admin.members.text72": "Pending",
  "admin.members.text73": "Added",
  "admin.members.text74": "Removed",
  "admin.members.text75": "Date: newest",
  "admin.members.text76": "Date: oldest",
  "admin.members.text77": "Name: A → Z",
  "admin.members.text78": "Name: Z → A",
  "admin.members.text79": "Status: A → Z",
  "admin.members.text80": "Status: Z → A",
  "admin.members.text81": "Last login (newest)",
  "admin.members.text82": "Last login (oldest)",
  "admin.members.text83": "Proton: all",
  "admin.members.text84": "Never exported",
  "admin.members.text85": "Exported, not synced",
  "admin.members.text86": "Synced",
  "admin.members.text87": "Loading...",
  "admin.members.text88": "No registrations",
  "admin.members.text89": "Select all",
  "admin.members.text90": "Last & first name",
  "admin.members.text91": "Email",
  "admin.members.text92": "Last login",
  "admin.members.text93": "WhatsApp",
  "admin.members.text94": "Source",
  "admin.members.text95": "Status",
  "admin.members.text96": "Consents",
  "admin.members.text97": "Date",
  "admin.members.text98": "Member access",
  "admin.members.text99": "Proton",
  "admin.members.text100": "Actions",
  "admin.members.text101": "Never logged in — click to view history",
  "admin.members.text102": "—",
  "admin.members.text103": "Terms",
  "admin.members.text104": "Charter",
  "admin.members.text105": "GDPR",
  "admin.members.text106": "Approved",
  "admin.members.text107": "Revoke",
  "admin.members.text108": "Grant",
  "admin.members.text109": "Member access must be approved first",
  "admin.members.text110": "Magic link history",
  "admin.members.text111": "The member has not requested to join the group",
  "admin.members.text112": "The member has already been added to the group",
  "admin.members.text113": "View status history",
  "admin.members.text114": "Delete member",
  "admin.members.text115": "Registration date",
  "admin.members.text116": "Access approved",
  "admin.members.text117": "Pending approval",
  "admin.members.text118": "Grant member access",
  "admin.members.text119": "Resend magic link",
  "admin.members.text120": "Invite",
  "admin.members.text121": "selected",
  "admin.members.text122": "Export",
  "admin.members.text123": "Mark as synced",
  "admin.members.text124": "Deselect",
  "admin.members.text125": "(",
  "admin.members.text126": "No Proton events for this member.",
  "admin.members.text127": "Exported (.vcf)",
  "admin.members.text128": "Marked as synced",
  "admin.members.text129": "Sync removed",
  "admin.members.text130": "Status reset",
  "admin.members.text131": "Bulk action",
  "admin.members.text132": "First export",
  "admin.members.text133": "Format:",
  "admin.members.text134": "Internal notes",
  "admin.members.text135": "Add a note",
  "admin.members.text136": "Enter your note here...",
  "admin.members.text137": "Add note",
  "admin.members.text138": "Existing notes (",
  "admin.members.text139": "No notes yet",
  "admin.members.text140": "Delete note",
  "admin.members.text141": "Status history",
  "admin.members.text142": "No history available",
  "admin.members.text143": "→",
  "admin.members.text144": "Collective charter acceptance",
  "admin.members.text145": "Loading…",
  "admin.members.text146": "No evidence recorded — registration predates the logging system.",
  "admin.members.text147": "Charter version",
  "admin.members.text148": "Date and time",
  "admin.members.text149": "IP address",
  "admin.members.text150": "Consent",
  "admin.members.text151": "User agent",
  "admin.members.text152": "Exact declaration text",
  "admin.members.text153": "Immutable record retained as legal evidence.",
  "admin.members.text154": "Privacy policy acceptance",
  "admin.members.text155": "Policy version",
  "admin.members.text156": "Confirm sending",
  "admin.members.text157": "Are you sure you want to send the WhatsApp invitation to",
  "admin.members.text158": ")?",
  "admin.members.text159": "Cancel",
  "admin.members.text160": "Confirm",
  "admin.members.text161": "Confirm sending magic link",
  "admin.members.text162": "Are you sure you want to send the magic link to",
  "admin.members.text163": "No magic links sent yet",
  "admin.members.text164": "Sent successfully",
  "admin.members.text165": "Failed",
  "admin.members.text166": "Email:",
  "admin.members.text167": "Confirm member area activation",
  "admin.members.text168": "Two emails will be sent to",
  "admin.members.text169": "):",
  "admin.members.text170": "1.",
  "admin.members.text171": "Activation confirmation email",
  "admin.members.text172": "2.",
  "admin.members.text173": "Email with the login link (remember to check spam)",
  "admin.members.text174": "Confirm activation",
  "admin.members.text175": "Confirm deletion",
  "admin.members.text176": "⚠️ This action cannot be undone!",
  "admin.members.text177": "You are about to permanently delete",
  "admin.members.text178": ").",
  "admin.members.text179": "This action will delete:",
  "admin.members.text180": "The registration",
  "admin.members.text181": "The member profile",
  "admin.members.text182": "The user account",
  "admin.members.text183": "All associated data (notes, history, etc.)",
  "admin.members.text184": "Permanently delete",
  "admin.members.text185": "Error",
  "admin.members.text186": "You must be logged in to setup 2FA",
  "admin.members.text187": "2FA Setup Started",
  "admin.members.text188": "Scan the QR code with your authenticator app",
  "admin.members.text189": "Failed to setup 2FA. Please try again.",
  "admin.members.text190": "Invalid Code",
  "admin.members.text191": "Please enter a 6-digit code",
  "admin.members.text192": "The verification code is incorrect",
  "admin.members.text193": "2FA Enabled",
  "admin.members.text194": "Two-factor authentication has been successfully enabled",
  "admin.members.text195": "Failed to enable 2FA. Please try again.",
  "admin.members.text196": "Are you sure you want to disable 2FA? This will make your account less secure.",
  "admin.members.text197": "2FA Disabled",
  "admin.members.text198": "Two-factor authentication has been disabled",
  "admin.members.text199": "Failed to disable 2FA. Please try again.",
  "admin.members.text200": "Copied",
  "admin.members.text201": "Copied to clipboard",
  "admin.members.text202": "Security — 2FA",
  "admin.members.text203": "Two-Factor Authentication (2FA)",
  "admin.members.text204": "Add an extra layer of security to your admin account",
  "admin.members.text205": "Two-factor authentication is currently",
  "admin.members.text206": "enabled",
  "admin.members.text207": "for your account. You'll be prompted for a code when logging in.",
  "admin.members.text208": "Disable 2FA",
  "admin.members.text209": "Save your backup codes!",
  "admin.members.text210": "They can be used to access your account if you lose your authenticator device.",
  "admin.members.text211": "Step 1: Scan QR Code",
  "admin.members.text212": "Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)",
  "admin.members.text213": "2FA QR Code",
  "admin.members.text214": "Or enter this code manually:",
  "admin.members.text215": "Step 2: Save Backup Codes",
  "admin.members.text216": "Store these codes in a safe place. Each code can only be used once.",
  "admin.members.text217": "Copy All Backup Codes",
  "admin.members.text218": "Step 3: Verify",
  "admin.members.text219": "Enter the 6-digit code from your authenticator app to complete setup",
  "admin.members.text220": "000000",
  "admin.members.text221": "Verify & Enable",
  "admin.members.text222": "disabled",
  "admin.members.text223": ". Enable it to add an extra layer of security to your admin account.",
  "admin.members.text224": "What you'll need:",
  "admin.members.text225": "An authenticator app (Google Authenticator, Authy, Microsoft Authenticator, etc.)",
  "admin.members.text226": "A safe place to store backup codes",
  "admin.members.text227": "Enable 2FA",
  "admin.members.text228": "Loading error",
  "admin.members.text229": "Unable to retrieve logs",
  "admin.members.text230": "CSV export generated",
  "admin.members.text231": "Access denied",
  "admin.members.text232": "This page is restricted to administrators.",
  "admin.members.text233": "Checking permissions…",
  "admin.members.text234": "Login attempts",
  "admin.members.text235": "Log of member and admin logins (password, 2FA, magic link). Emails are stored",
  "admin.members.text236": "in plain text",
  "admin.members.text237": ", access is",
  "admin.members.text238": "restricted to administrators",
  "admin.members.text239": "(RLS) and retention is",
  "admin.members.text240": "90 days",
  "admin.members.text241": ". No passwords or 2FA codes are stored.",
  "admin.members.text242": "Export CSV (",
  "admin.members.text243": "Filters",
  "admin.members.text244": "Refine by period, result, area or method.",
  "admin.members.text245": "Email, IP, reason…",
  "admin.members.text246": "Result",
  "admin.members.text247": "All results",
  "admin.members.text248": "Success",
  "admin.members.text249": "Area",
  "admin.members.text250": "All areas",
  "admin.members.text251": "Admin",
  "admin.members.text252": "Member",
  "admin.members.text253": "Method",
  "admin.members.text254": "All methods",
  "admin.members.text255": "Password",
  "admin.members.text256": "2FA",
  "admin.members.text257": "Magic link",
  "admin.members.text258": "Start date",
  "admin.members.text259": "Refresh",
  "admin.members.text260": "Clear filters",
  "admin.members.text261": "entry",
  "admin.members.text262": "Attempts",
  "admin.members.text263": "Limited to the latest 1,000 entries.",
  "admin.members.text264": "No attempts match these criteria.",
  "admin.members.text265": "Reason:",
  "admin.members.text266": "ip:",
  "admin.members.text267": "ua:",
  "admin.members.text268": "Invalid IP address",
  "admin.members.text269": "This IP is already in the list",
  "admin.members.text270": "Error adding",
  "admin.members.text271": "IP added",
  "admin.members.text272": "Update error",
  "admin.members.text273": "Deletion error",
  "admin.members.text274": "IP deleted",
  "admin.members.text275": "Forced Cloudflare challenge by IP",
  "admin.members.text276": "The IP addresses listed below automatically receive the Cloudflare challenge (Turnstile) for each new session, regardless of behavioral analysis. Disable an entry to suspend it temporarily, or delete it to permanently remove the rule.",
  "admin.members.text277": "Add an IP",
  "admin.members.text278": "e.g. 193.39.2.173",
  "admin.members.text279": "Reason (optional)",
  "admin.members.text280": "e.g. iAdvize visits bot",
  "admin.members.text281": "Add",
  "admin.members.text282": "Configured IPs (",
  "admin.members.text283": "No forced IPs yet.",
  "admin.members.text284": "IP",
  "admin.members.text285": "Reason",
  "admin.members.text286": "Added on",
  "admin.members.text287": "Active",
  "admin.members.text288": "Delete this IP?",
  "admin.members.text289": "The IP",
  "admin.members.text290": "will no longer automatically receive the Cloudflare challenge.",
  "admin.members.text291": "Delete",
  "admin.members.text292": "Error",
  "admin.members.text293": "Label required",
  "admin.members.text294": "Canary created",
  "admin.members.text295": "Token copied",
  "admin.members.text296": "Access denied.",
  "admin.members.text297": "Content canaries",
  "admin.members.text298": "New canary",
  "admin.members.text299": "What are canaries for?",
  "admin.members.text300": "Each canary is a unique token invisibly inserted into the public site's prerendered HTML (comment + span",
  "admin.members.text301": "font-size:0",
  "admin.members.text302": "). If it appears elsewhere (competing article, resold database, cached copy), it is evidence of exfiltration. Search for it periodically.",
  "admin.members.text303": "Canaries",
  "admin.members.text304": "The first active canary is inserted at each build. Create a new one periodically to date a potential leak.",
  "admin.members.text305": "No canaries.",
  "admin.members.text306": "Token",
  "admin.members.text307": "Label",
  "admin.members.text308": "Created",
  "admin.members.text309": "Disabled",
  "admin.members.text310": "Inactive",
  "admin.members.text311": "Copy token",
  "admin.members.text312": "Search the web",
  "admin.members.text313": "Disable",
  "admin.members.text314": "Reactivate",
  "admin.members.text315": "Generates a unique token. It will be inserted into the HTML at the next build.",
  "admin.members.text316": "Label (e.g. July 2026)",
  "admin.members.text317": "Disable previous canaries",
  "admin.members.text318": "Creating…",
  "admin.members.text319": "Create",
  "admin.members.text320": "Search for the leak",
  "admin.members.text321": "Allowlisted",
  "admin.members.text322": "Blocked",
  "admin.members.text323": "Automatically blocked",
  "admin.members.text324": "Network",
  "admin.members.text325": "CF active",
  "admin.members.text326": "CF not applied",
  "admin.members.text327": "Cloudflare network rule applied",
  "admin.members.text328": "Unable to block at network level",
  "admin.members.text329": "Cloudflare is not configured or the API refused the request. The local rule (Actions) was applied.",
  "admin.members.text330": "Rule saved",
  "admin.members.text331": "Rule deleted",
  "admin.members.text332": "IP allowlisted",
  "admin.members.text333": "Access & blocks",
  "admin.members.text334": "Manually block IP addresses and networks (ASN). Verified crawlers (Googlebot, Bingbot, …) are never blocked.",
  "admin.members.text335": "ASN",
  "admin.members.text336": "Block",
  "admin.members.text337": "Allowlist",
  "admin.members.text338": "Level",
  "admin.members.text339": "Actions (app)",
  "admin.members.text340": "Network – Cloudflare",
  "admin.members.text341": "Reason (optional)",
  "admin.members.text342": "ℹ️",
  "admin.members.text343": ": blocks registration, contact and login but retains visits.",
  "admin.members.text344": "Network (Cloudflare)",
  "admin.members.text345": ": blocks the entire site through a Cloudflare rule.",
  "admin.members.text346": "The level",
  "admin.members.text347": "requires Cloudflare secrets (CLOUDFLARE_API_TOKEN, CLOUDFLARE_ZONE_ID) to be configured; otherwise blocking falls back to level",
  "admin.members.text348": ".",
  "admin.members.text349": "Blocking an ASN immediately blocks IPs on that network",
  "admin.members.text350": "already observed",
  "admin.members.text351": "on the site. New IPs from the same ASN will be denied when they attempt access.",
  "admin.members.text352": "Type",
  "admin.members.text353": "Target",
  "admin.members.text354": "Reason",
  "admin.members.text355": "Affected IPs",
  "admin.members.text356": "Updated",
  "admin.members.text357": "No access rules.",
  "admin.members.text358": "Unblock",
  "admin.members.text359": "Member deleted",
  "admin.members.text360": "Status changed",
  "admin.members.text361": "Token cleanup",
  "admin.members.text362": "Proton export (.vcf)",
  "admin.members.text363": "Proton synced",
  "admin.members.text364": "Proton sync removed",
  "admin.members.text365": "Proton status reset",
  "admin.members.text366": "Verification tokens",
  "admin.members.text367": "Unable to load audit logs",
  "admin.members.text368": "System",
  "admin.members.text369": "Audit logs",
  "admin.members.text370": "Search...",
  "admin.members.text371": "Action type",
  "admin.members.text372": "All actions",
  "admin.members.text373": "Administrator",
  "admin.members.text374": "All admins",
  "admin.members.text375": "result",
  "admin.members.text376": "Action history",
  "admin.members.text377": "All sensitive administrative actions are recorded here",
  "admin.members.text378": "No audit logs found",
  "admin.members.text379": "Turnstile not configured",
  "admin.members.text380": "Turnstile not checked",
  "admin.members.text381": "Turnstile expired",
  "admin.members.text382": "Missing “other” details",
  "admin.members.text383": "Missing phone number",
  "admin.members.text384": "Invalid phone number",
  "admin.members.text385": "DB error (email check)",
  "admin.members.text386": "Email already registered",
  "admin.members.text387": "DB error (insertion)",
  "admin.members.text388": "Resend email failed",
  "admin.members.text389": "Unhandled exception",
  "admin.members.text390": "Registration logs",
  "admin.members.text391": "Failures returned by the registration function (Turnstile, duplicates, Resend, server errors…). Emails are stored as SHA-256 hashes to protect privacy.",
  "admin.members.text392": "Search (code, IP, requestId…)",
  "admin.members.text393": "Error code",
  "admin.members.text394": "All codes",
  "admin.members.text395": "failure",
  "admin.members.text396": "Incidents",
  "admin.members.text397": "Limited to the latest 1,000 entries. Refine the filters to target a specific period or error code.",
  "admin.members.text398": "No registration failures match these criteria.",
  "admin.members.text399": "HTTP",
  "admin.members.text400": "requestId:",
  "admin.members.text401": "email#:",
  "admin.members.text402": "…",
  "admin.members.text403": "Technical details",
  "admin.members.text404": "Login history",
  "admin.members.text405": "Last 50 recorded logins.",
  "admin.members.text406": "No logins recorded.",
  "admin.members.text407": "IP:",
  "admin.members.text408": "Search engine",
  "admin.members.text409": "Other",
  "admin.members.text410": "Member profile",
  "admin.members.text411": "Registration",
  "admin.members.text412": "Last name",
  "admin.members.text413": "End date",
  "admin.members.text414": "Not logged in",
  "admin.members.text415": "Synced on {v0}",
  "admin.members.text416": "Exported on {v0}",
  "admin.members.text417": "vCard exported successfully ({v0} contacts)",
  "admin.members.text418": "{v0} member(s) marked as synced",
  "admin.members.text419": "Processing {v0} registration(s)...",
  "admin.members.text420": "{v0} successful action(s)",
  "admin.members.text421": "{v0} successful, {v1} failed",
  "admin.members.text422": "Select {v0} {v1}",
  "admin.members.text423": "{v0} — click to view history",
  "admin.members.text424": "Internal notes ({v0})",
  "admin.members.text425": "Charter dated {v0} accepted",
  "admin.members.text426": "Charter dated {v0} not accepted",
  "admin.members.text427": "Privacy policy dated {v0} accepted",
  "admin.members.text428": "Privacy policy dated {v0} not accepted",
  "admin.members.text429": "Never",
  "admin.members.text430": "Invalid date",
  "admin.members.text431": "{date} at {time}",
  "admin.members.text432": "{v0} row(s) exported.",
  "admin.members.text433": "Last 50 logins for {v0}.",
  "admin.members.unknownAdmin": "Unknown admin"
} as const;

export default membersEn;
